
import Logger from '@/logger'

const LOG_NAME = 'Hubspot'

/**
 * Tracks events in Hubspot.
 * @export Hubspot
 * @class Hubspot
 */
export default class {
    /**
     * Creates an instance of Hubspot.
     */
    contructor() {
        this.enabled = true
    }

    /**
     * Sends an event to Hubspot. Hubspot takes all tracking in the form of an array
     * with the first parameter as the event name and the second parameter as the
     * data for the event.
     * @param {Array} event
     */
    track(event) {
        if (!this.enabled)
            return

        Logger.logObject(event, 'Tracking Hubspot event', LOG_NAME)

        const _hsq = window._hsq = window._hsq || []
        _hsq.push(event)
        _hsq.push([ 'trackPageView' ])
    }
}
